import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';
import { ExcelPasteDetector } from './paste-classification.util';

@Directive({
  selector: '[appFormatStringInput]',
  standalone: true,
})
export class FormatStringInputDirective extends ExcelPasteDetector {
  @Output() dataChanged = new EventEmitter<string | null>();

  private el: HTMLTextAreaElement;
  private savedValue?: string | null;
  private currentValue = '';

  constructor(private elementRef: ElementRef) {
    super();
    this.el = this.elementRef.nativeElement;
  }

  @HostListener('focus')
  onFocus(): void {
    this.savedValue = this.el.value;
    this.currentValue = this.el.value;
  }

  @HostListener('input')
  onInput(): void {
    this.currentValue = this.el.value;
  }

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' && (event.ctrlKey || event.metaKey)) {
      event.preventDefault();
      event.stopPropagation();
      const start = this.el.selectionStart;
      const end = this.el.selectionEnd;
      const value = this.el.value;
      this.el.value = value.substring(0, start) + '\n' + value.substring(end);
      this.el.selectionStart = this.el.selectionEnd = start + 1;
      this.currentValue = this.el.value;
      this.el.dispatchEvent(new Event('input'));
    } else if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      this.emitValue();
    }
  }

  @HostListener('document:mousedown', ['$event'])
  mouseDown(event: MouseEvent): void {
    const isInputFocused = document.activeElement === this.el;
    const targetElement = event.target as HTMLElement | null;
    const clickedOutside = !targetElement || !this.el.contains(targetElement);
    if (isInputFocused && clickedOutside) {
      this.emitValue();
    }
  }

  @HostListener('blur')
  onBlur(): void {
    this.emitValue();
  }

  private emitValue(): void {
    const value = this.currentValue;
    if (value.length === 0) {
      if (value !== this.savedValue) {
        this.dataChanged.emit(null);
        this.savedValue = value;
      }
    } else {
      if (value !== this.savedValue) {
        this.dataChanged.emit(value);
        this.savedValue = value;
      }
    }
  }
}
